<main class="main-container">
  <app-header class=""></app-header>
  <app-toolbar class=""></app-toolbar>
  <div class="planning w-full min-w-[900px]">
    <div class="planning-table grid-flow-row border-r-[3px] border-[#27368A]">
      <div class="card relative">
        <ng-container *ngIf="(viewTab['months'] || viewTab['days']) && this.tabs[this.activeIndex] == 'planning'">
          <div class="absolute right-[7px] top-[7px] z-10">
            <div class="relative">
              <p-calendar [(ngModel)]="selectedDate" [view]="viewTab['months'] ? 'month' : 'date'"
                [dateFormat]="viewTab['months'] ? 'mm/yy' : 'dd/mm/yy'" [firstDayOfWeek]="1" [readonlyInput]="true"
                inputId="picker-calendar" (onSelect)="selectDateOnCalendar($event)"
                [style.display]="showCalendar ? 'block' : 'none'" [style.width]="'400px'" [inline]="true"
                [locale]="spanishLocale" #calendar>
              </p-calendar>
              <label (click)="manageCalendar($event)" #btnOpenCalendar
                class="bg-[#429DCF] text-white text-[15px] font-[600] rounded-[12px] px-[10px] py-[7px] flex gap-2 items-center mb-3 cursor-pointer">
                <img src="/assets/icons/icon-calendar.png" class="w-[20px]" alt="" />
                {{ viewTab['months'] ? 'Mes' : 'Día' }}
                <img src="/assets/icons/arrow-down.png" class="w-[10px] pt-1" alt="" />
              </label>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="this.tabs[this.activeIndex] == 'collected'">
          <div class="absolute right-[7px] top-[7px] z-10">
            <div class="relative">
              <p-calendar [(ngModel)]="collectedDate" [view]="'date'"
                [dateFormat]="'dd/mm/yy'" [firstDayOfWeek]="1" [readonlyInput]="true"
                inputId="picker-calendar" (onSelect)="selectCollectedDateOnCalendar($event)"
                [style.display]="showCalendar ? 'block' : 'none'" [style.width]="'400px'" [inline]="true"
                [locale]="spanishLocale" #calendar>
              </p-calendar>
              <label (click)="manageCalendar($event)" #btnOpenCalendar
                class="bg-[#429DCF] text-white text-[15px] font-[600] rounded-[12px] px-[10px] py-[7px] flex gap-2 items-center mb-3 cursor-pointer">
                <img src="/assets/icons/icon-calendar.png" class="w-[20px]" alt="" />
                {{ 'Día' }}
                <img src="/assets/icons/arrow-down.png" class="w-[10px] pt-1" alt="" />
              </label>
            </div>
          </div>
        </ng-container>
        <p-tabView [(activeIndex)]="activeIndex" (onChange)="onChangeTab($event)">
          <p-tabPanel header="Planning">
            <div class="calendar-controls flex items-center justify-between mb-4">
              <div class="flex gap-2 items-center">
                <div class="flex gap-4 items-center">
                  <button type="button" (click)="resetDateSelector()"
                    class="py-[5px] px-[10px] border-[1px] border-solid border-[#A3A3A3] rounded-[8px] font-[600] text-[12px] text-[#5C5C5C]">
                    Mes actual
                  </button>
                </div>
                <div class="flex gap-2 items-center">
                  <div (click)="moveDate(-1)"
                    class="bg-[#429DCF] text-white px-1 pb-[2px] h-[15px] rounded-[3px] font-[600] text-[12px] leading-[1.2] cursor-pointer select-none">
                    &lt;
                  </div>
                  <div (click)="moveDate(1)"
                    class="bg-[#429DCF] text-white px-1 pb-[2px] h-[15px] rounded-[3px] font-[600] text-[12px] leading-[1.2] cursor-pointer select-none">
                    &gt;
                  </div>
                </div>
                <ng-container *ngIf="viewTab['months']">
                  <p class="ml-[15px] font-[600] text-[#5C5C5C] text-[12px]">
                    {{ selectedDate | date:'MMMM yyyy' }}
                  </p>
                </ng-container>
                <ng-container *ngIf="viewTab['days']">
                  <p class="ml-[15px] font-[600] text-[#5C5C5C] text-[12px]">
                    {{ selectedDate | date:'dd MMMM yyyy' }}
                  </p>
                </ng-container>
              </div>

              <div class="container-filter-select" *ngIf="viewTab['months'] || viewTab['days']">
                <select (change)="filterByService($event)" class="text-[12px]" #filterSelectServices>
                  <option value="all">Todos los servicios</option>
                  <option *ngFor="let service of planningGroupNames" [value]="service">{{ service }}</option>
                </select>
              </div>

              <ng-container *ngIf="viewTab['days']">
                <div class="flex gap-4 items-center content-between cursor-pointer" (click)="backZoom()">
                  <img src="/assets/icons/arrow-back-outline.png" alt="" />
                  <span class="text-[#5C5C5C] text-[12px] font-[600]">Volver atras</span>
                </div>
              </ng-container>
            </div>

            <!-- Vista de Mes -->
            <div class="relative overflow-x-auto rounded-[8px] mb-10 month-view-table" *ngIf="viewTab['months']">
              <div class="scrollable-table table-container" #tableMonthContainer>
                <table class="">
                  <thead>
                    <tr>
                      <th class="date-column">Fecha</th>
                      <th>Servicios</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let day of filteredMonthData" [class.past-date]="isPastDate(day.date)" #rowDate>
                      <td class="date-container">
                        <div class="date-wrapper text-center">
                          {{ day.date | date:'dd-MM-yyyy' }} <br />
                          {{ day.date | date:'EEEE':'':'es-ES' }}
                          <button class="zoom-btn" (click)="zoomToDay(day.date)">Zoom</button>
                        </div>
                      </td>
                      <td>
                        <div class="services-container">
                          <div *ngFor="let group of day.planning_group" class="service-card"
                            [ngStyle]="{'background-color': group.group_background_color == null ? null : group.group_background_color, 'color': group.group_text_color == null ? null : group.group_text_color, 'border-color':  group.group_border_color == null ? null : group.group_border_color}">
                            <div class="service-card-inner">
                              <div class="flex justify-between">
                                <label class="custom-checkbox">
                                  <input type="checkbox"
                                    [checked]="checkSelectedDateService(day.date, group.group_name, false)"
                                    (change)="loadItemsByMonth(day.date, group.group_name, $event)" />
                                  <span class="checkmark"></span>
                                </label>
                                <figure>
                                  <img [src]="environment.baseUrlWeb+'/files/'+group.group_icon"
                                    class="w-[25px] h-[25px]" alt="">
                                </figure>

                              </div>
                              <div class="group-info">
                                <span>{{ group.group_name }} x {{ group.total_tickets }}</span>
                              </div>
                              <table>
                                <thead>
                                  <tr>
                                    <th
                                      [ngStyle]="{'background-color': group.group_background_color == null ? null : group.group_background_color, 'color': group.group_text_color == null ? null : group.group_text_color, 'border-color': group.group_border_color == null ? null : group.group_border_color}">
                                      Servicios</th>
                                    <ng-container *ngIf="group.groups.length > 0">
                                      <th
                                        [ngStyle]="{'background-color': group.group_background_color == null ? null : group.group_background_color, 'color': group.group_text_color == null ? null : group.group_text_color, 'border-color': group.group_border_color == null ? null : group.group_border_color}">
                                        Grupos</th>
                                    </ng-container>
                                    <ng-container *ngIf="group.takepoints.length > 0">
                                      <th
                                        [ngStyle]="{'background-color': group.group_background_color == null ? null : group.group_background_color, 'color': group.group_text_color == null ? null : group.group_text_color, 'border-color': group.group_border_color == null ? null : group.group_border_color}">
                                        Puntos de Encuentro</th>
                                    </ng-container>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td
                                      [ngStyle]="{'background-color': group.group_background_color == null ? null : group.group_background_color, 'color': group.group_text_color == null ? null : group.group_text_color, 'border-color': group.group_border_color == null ? null : group.group_border_color}">
                                      <div *ngFor="let service of group.services">
                                        {{ service.name }} x {{ service.quantity }}
                                      </div>
                                    </td>
                                    <td *ngIf="group.groups.length > 0"
                                      [ngStyle]="{'background-color': group.group_background_color == null ? null : group.group_background_color, 'color': group.group_text_color == null ? null : group.group_text_color, 'border-color': group.group_border_color == null ? null : group.group_border_color}">
                                      <div *ngFor="let grp of group.groups">
                                        {{ grp.name }} x {{ grp.quantity }}
                                      </div>
                                    </td>
                                    <td *ngIf="group.takepoints.length > 0"
                                      [ngStyle]="{'background-color': group.group_background_color == null ? null : group.group_background_color, 'color': group.group_text_color == null ? null : group.group_text_color, 'border-color': group.group_border_color == null ? null : group.group_border_color}">
                                      <div *ngFor="let takepoint of group.takepoints">
                                        {{ takepoint.address }} x {{ takepoint.quantity }}
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <div class="card-footer">
                                <button (click)="openBookingByDateServiceDialog(day.date, group.group_name)">
                                  Ver Reservas
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Vista de Días -->
            <div class="relative overflow-x-auto rounded-[8px] mb-10" *ngIf="viewTab['days']">
              <div class="scrollable-table" #tableDayContainer>
                <table class="table-auto border-collapse w-full">
                  <thead>
                    <tr class="border-b border-gray-200">
                      <th class="hour-column p-2">Hora</th>
                      <th *ngFor="let groupName of planningGroupNames" class="p-2"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let hour of filteredHourData; let i = index" class="border-t border-gray-200">
                      <td class="hour-container p-2 border-r border-gray-200">
                        <div class="hour-wrapper">
                          {{ hour.hour }}
                        </div>
                      </td>
                      <ng-container *ngFor="let group of hour.planning_group; let j = index">
                        <ng-container *ngIf="!isCellOccupied(i, j); else emptyCell">
                          <td *ngIf="hasGroupStartingAt(hour.hour, group.group_name)"
                            [attr.rowspan]="getGroupDuration(hour.hour, group.group_name)"
                            class="p-2 border-r border-gray-200">
                            <div class="services-container w-full">
                              <div class="service-card w-full" [ngClass]="{
                                '!bg-red-200 !border !border-red-300':
                                  getGroupServices(hour.hour, group.group_name).is_blocked,
                                '!border !border-gray-200':
                                  !getGroupServices(hour.hour, group.group_name).is_blocked
                              }"
                                [ngStyle]="{'background-color': getGroupServices(hour.hour, group.group_name).is_blocked == true ? '' : group.group_background_color, 'color': getGroupServices(hour.hour, group.group_name).is_blocked == true ? '' : group.group_text_color, 'border-color': group.group_border_color == null ? null : group.group_border_color}">
                                <div class="service-card-inner">
                                  <div class="flex justify-between">
                                    <label class="custom-checkbox">
                                      <input type="checkbox"
                                        [checked]="checkSelectedDateService(formatDate(selectedDate), group.group_name, hour.hour)"
                                        (change)="loadItemsByHour(formatDate(selectedDate), hour.hour, group.group_name, $event)" />
                                      <span class="checkmark"></span>
                                    </label>
                                    <div class="flex gap-1 items-center">
                                      <ng-container *ngIf="canChangeStatusService">
                                        <figure>
                                          <img (click)="
                                                toggeBlockDate(
                                                  hour.hour,
                                                  group.group_name
                                                )
                                              " class="w-[17px] cursor-pointer bg-white rounded-full"
                                            [src]="(getGroupServices(hour.hour, group.group_name).is_blocked)? './assets/svg/check-icon.svg': './assets/svg/block-icon.svg'"
                                            alt="" />
                                        </figure>

                                      </ng-container>
                                      <figure>
                                        <img [src]="environment.baseUrlWeb+'/files/'+group.group_icon"
                                          class="w-[25px] h-[25px]" alt="">
                                      </figure>

                                    </div>
                                  </div>
                                  <div class="group-info">
                                    <span>{{ getGroupTotalTickets(hour.hour, group.group_name) }} x {{ group.group_name
                                      }}</span>
                                  </div>
                                  <table class="table-auto w-full">
                                    <thead>
                                      <tr>
                                        <th class="p-1"
                                          [ngStyle]="{'background-color': getGroupServices(hour.hour, group.group_name).is_blocked == true ? '' : group.group_background_color, 'color': getGroupServices(hour.hour, group.group_name).is_blocked == true ? '' : group.group_text_color, 'border-color': group.group_border_color == null ? null : group.group_border_color}">
                                          Servicios</th>
                                        <ng-container
                                          *ngIf="getGroupServices(hour.hour, group.group_name).groups.length > 0">
                                          <th class="p-1"
                                            [ngStyle]="{'background-color': getGroupServices(hour.hour, group.group_name).is_blocked == true ? '' : group.group_background_color, 'color': getGroupServices(hour.hour, group.group_name).is_blocked == true ? '' : group.group_text_color, 'border-color': group.group_border_color == null ? null : group.group_border_color}">
                                            Grupos</th>
                                        </ng-container>
                                        <ng-container
                                          *ngIf="getGroupServices(hour.hour, group.group_name).takepoints.length > 0">
                                          <th class="p-1"
                                            [ngStyle]="{'background-color': getGroupServices(hour.hour, group.group_name).is_blocked == true ? '' : group.group_background_color, 'color': getGroupServices(hour.hour, group.group_name).is_blocked == true ? '' : group.group_text_color, 'border-color': group.group_border_color == null ? null : group.group_border_color}">
                                            Puntos de Encuentro</th>
                                        </ng-container>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td class="p-1"
                                          [ngStyle]="{'background-color': getGroupServices(hour.hour, group.group_name).is_blocked == true ? '' : group.group_background_color, 'color': getGroupServices(hour.hour, group.group_name).is_blocked == true ? '' : group.group_text_color, 'border-color': group.group_border_color == null ? null : group.group_border_color}">
                                          <div
                                            *ngFor="let service of getGroupServices(hour.hour, group.group_name).services">
                                            {{ service.name }} x {{ service.quantity }}
                                          </div>
                                        </td>
                                        <td *ngIf="getGroupServices(hour.hour, group.group_name).groups.length > 0"
                                          class="p-1"
                                          [ngStyle]="{'background-color': getGroupServices(hour.hour, group.group_name).is_blocked == true ? '' : group.group_background_color, 'color': getGroupServices(hour.hour, group.group_name).is_blocked == true ? '' : group.group_text_color, 'border-color': group.group_border_color == null ? null : group.group_border_color}">
                                          <div *ngFor="let grp of getGroupServices(hour.hour, group.group_name).groups">
                                            {{ grp.name }} x {{ grp.quantity }}
                                          </div>
                                        </td>
                                        <td *ngIf="getGroupServices(hour.hour, group.group_name).takepoints.length > 0"
                                          class="p-1"
                                          [ngStyle]="{'background-color': getGroupServices(hour.hour, group.group_name).is_blocked == true ? '' : group.group_background_color, 'color': getGroupServices(hour.hour, group.group_name).is_blocked == true ? '' : group.group_text_color, 'border-color': group.group_border_color == null ? null : group.group_border_color}">
                                          <div
                                            *ngFor="let takepoint of getGroupServices(hour.hour, group.group_name).takepoints">
                                            {{ takepoint.address }} x {{ takepoint.quantity }}
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div class="card-footer mt-2">
                                  <button
                                    (click)="openBookingByDateServiceDialog(formatDate(selectedDate), group.group_name, hour.hour)">
                                    Ver Reservas
                                  </button>
                                </div>
                              </div>
                            </div>
                          </td>
                        </ng-container>
                      </ng-container>
                      <ng-template #emptyCell>
                        <td class="p-2 border-r border-gray-200"></td>
                      </ng-template>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="relative overflow-x-auto rounded-[8px] mb-10" *ngIf="viewTab['hours']">
              <p>Detalle por hora concreta</p>
            </div>
          </p-tabPanel>
          <p-tabPanel header="Recogidas">
            <app-planning-meetings [selectedDate]="collectedDate" ></app-planning-meetings>
          </p-tabPanel>
        </p-tabView>
      </div>
    </div>
    <div>
      <div class="header-inventory">
        <ul>
          <li>Inventario</li>
        </ul>
      </div>
      <div class="body-inventory p-[1rem] sticky top-0 z-[50]">
        <div class="relative overflow-x-auto table-container">
          <table class="w-full text-sm text-left rtl:text-right text-gray-500 !rounded-md">
            <thead class="text-[12px] text-[#5C5C5C] uppercase bg-[#E9E9E9]">
              <tr>
                <th scope="col" class="px-6 py-3">Items</th>
                <th scope="col" class="px-6 py-3">Cantidad</th>
              </tr>
            </thead>
            <tbody class="bg-[#F4F4F4] divide-y-[3px] divide-[#E6E6E6]">
              <ng-container *ngIf="selectedItems.length > 0; else noDataItems">
                <ng-container *ngFor="let item of selectedItems">

                  <tr class="text-[#383838] text-[12px] font-[300]" *ngIf="item.units > 0">
                    <td scope="row" class="px-6 py-4 whitespace-nowrap">
                      {{ item.name }} - {{ item.size }}
                    </td>
                    <td class="px-6 py-4">x{{ item.units }}</td>
                  </tr>
                </ng-container>
              </ng-container>
              <ng-template #noDataItems>
                <tr class="text-[#383838] text-[12px] font-[300]">
                  <td scope="row" colspan="2" class="px-6 py-4 whitespace-nowrap text-center">
                    No hay items existentes
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
      <div class="body-inventory p-[1rem]">
        <div class="relative overflow-x-auto table-container">
          <table class="w-full text-sm text-left rtl:text-right text-gray-500">
            <thead class="text-[12px] text-[#5C5C5C] uppercase bg-[#E9E9E9]">
              <tr>
                <th scope="col" class="px-6 py-3">Referencia</th>
                <th scope="col" class="px-6 py-3">Items</th>
                <th scope="col" class="px-6 py-3">Bidones</th>
              </tr>
            </thead>
            <tbody class="bg-[#F4F4F4] divide-y-[3px] divide-[#E6E6E6]">
              <ng-container *ngIf="drumsAndItemsByBooking.length > 0; else noDataDrums">
                <ng-container *ngFor="let booking of drumsAndItemsByBooking">

                  <tr class="text-[#383838] text-[12px] font-[300]"
                    *ngIf="(booking.item_services && booking.item_services.length > 0) || (booking.drums && booking.drums.length > 0)">

                    <td scope="row" class="px-6 py-4 whitespace-nowrap">
                      {{ booking.booking_reference }}
                    </td>
                    <td>
                      <span class="block whitespace-nowrap" *ngFor="let itemService of booking.item_services">
                        <label class="text-[12px] font-[600] text-[#5C5C5C] block"
                          *ngIf="itemService.items && itemService.items.length > 0">{{ itemService.service }}</label>
                        <span class="whitespace-nowrap block" *ngFor="let item of itemService.items">
                          {{ item.name }} x{{ item.units }}
                        </span>
                      </span>
                    </td>
                    <td class="px-6 py-4">
                      <span class="block whitespace-nowrap" *ngFor="let itemService of booking.item_services">
                        <label class="text-[12px] font-[600] text-[#5C5C5C] block"
                          *ngIf="itemService.drums && itemService.drums.length > 0">{{ itemService.service }}</label>
                        <span class="whitespace-nowrap block">
                          {{ (itemService.drums && itemService.drums.length > 0) ? itemService.drums.join(', ') : 'Sin
                          Bidones' }}
                        </span>
                      </span>

                    </td>
                  </tr>
                </ng-container>
              </ng-container>
              <ng-template #noDataDrums>
                <tr class="text-[#383838] text-[12px] font-[300]">
                  <td scope="row" colspan="3" class="px-6 py-4 whitespace-nowrap ">
                    <span class="block">No hay bidones o items existentes</span>

                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="viewTab['days']">
    <div class="fixed right-[15px] bottom-[15px] py-[7px] px-[15px] bg-[#429DCF] text-white rounded-full opacity-40 hover:opacity-100 cursor-pointer z-[100] transition-all duration-300 ease-in-out">
      <p>han participado: {{ totalParticipantsConfirmed }}/{{ totalParticipants }}</p>
    </div>
  </ng-container>
</main>
